const kollectAiRoles = {
  permissionList: '/account/api/v1/roles_and_permissions/permissions_list',
  roles: '/account/api/v1/roles_and_permissions/roles',
};

export default kollectAiRoles;
